module.exports = __webpack_public_path__ + "static/media/portada-pagina.20d4d901.jpg";